import Vue from 'vue';
import Router from 'vue-router';

import menuModule from 'vuex-store/modules/menu';
import lazyLoading from '@/store/modules/menu/lazyLoading';

Vue.use(Router);

// const demoRoutes = [];
// if (process.env.NODE_ENV === 'development') {
//   const VueComponentTree = require('vue-component-tree');
//
//   demoRoutes.push(
//     VueComponentTree.default(require.context('./..', true, /.demo.vue$/), '/demo'),
//   );
// }

export default new Router({
  mode: 'history',
  routes: [
    // ...demoRoutes,
    ...generateRoutesFromMenu(menuModule.state.items),
    {
      name: 'Signup',
      path: '/auth/signup',
      component: lazyLoading('auth/signup/Signup'),
      meta: {
        title: 'menu.signUp',
        newWindow: true
      }
    },
    {
      path: '*',
      redirect: { name: getDefaultRoute(menuModule.state.items).name },
    },
  ],
});

function generateRoutesFromMenu (menu = [], routes = []) {
  for (let i = 0, l = menu.length; i < l; i++) {
    let item = menu[i];
    if (item.path) {
      routes.push(item);
    }
    if (item.children) {
      generateRoutesFromMenu(item.children, routes);
    }
  }
  return routes;
}

function getDefaultRoute (menu = []) {
  let defaultRoute;

  menu.forEach((item) => {
    if (item.meta.default) {
      defaultRoute = item;
    } else if (item.children) {
      let defaultChild = item.children.find((i) => i.meta.default);
      defaultRoute = defaultChild || defaultRoute;
    }
  });

  return defaultRoute;
}



// WEBPACK FOOTER //
// ./src/router/index.js